'use strict';

import { GLOBAL } from './Global';
import { SMART_DATA as SMART_DATA_PERMISSION_GROUPS } from '../PermissionsGroups';

const smart_data_permissions_list = [];

for (const [key, value] of Object.entries(SMART_DATA_PERMISSION_GROUPS)) {
  smart_data_permissions_list.push({
    action_list: value,
    element: key,
  });
}

const SMART_DATA = {
  can: [
    ...GLOBAL.can,
    ...smart_data_permissions_list,
  ],
};

export {
  SMART_DATA,
};
